import { LoaderInterfaceState, initialLoaderState } from '../state/loader.state';
import { LoaderActions, ELoaderActions } from '../actions/loader.actions';

export function loaderReducer(state: LoaderInterfaceState = initialLoaderState, action: LoaderActions): LoaderInterfaceState {
  switch (action.type) {
    case ELoaderActions.UpdateLoaderVisibility: {
      return { ...state, visibility: action.payload };
    }

    default:
      return initialLoaderState;
  }
};
